var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"logout","light":""}},[_c('v-layout',{staticStyle:{"margin-top":"1em"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }